import { styled } from "@mui/material/styles";
import { Switch } from "@mui/material";

export interface AppSwitchProps {
    onSwitchChange: () => void;
    checked: boolean;
}

const StyledSwitch = styled(Switch)(({ theme }) => ({
    "& .Mui-checked": {
        color: theme.palette.primary.main,
    },
    "& .Mui-checked+.MuiSwitch-track": {
        background: theme.palette.primary.main,
    },
    "& .MuiSwitch-track": {
        backgroundColor: theme.palette.grey["A100"],
    },
}));

export const AppSwitch = (props: AppSwitchProps) => {
    const { onSwitchChange, checked } = props;

    return (
        <StyledSwitch
            checked={checked}
            size="medium"
            color="primary"
            onChange={onSwitchChange}
        />
    );
};
